module.exports = __webpack_public_path__ + "fonts/Lato-BlackItalic.6cad9641.woff";